import { createTheme } from '@mui/material/styles';
import { PolcoColor } from './colors-class';

// NOTE: Slightly customized away from Material Design best practices
// for consistency with existing pages. We'll come back to that once
// we've finished migrating our design system to MD, and code to MUI.
export const theme = createTheme({
  palette: {
    primary: { main: new PolcoColor('Polco-Green').hex },
    secondary: { main: new PolcoColor('Jungle').hex },
    error: { main: new PolcoColor('Error').hex },
  },
  components: {
    MuiButton: {
      defaultProps: {
        // Our existing buttons are Jungle.
        // And Polco-Green looks kinda like vomit on a button,
        // especially in e.g. hover states :P
        color: 'secondary',
      },
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontWeight: 400,
          textTransform: 'none',
        },
      },
    },
  },
  typography: {
    h1: {
      fontSize: '2.5rem',
      fontWeight: 400,
      lineHeight: '3rem',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: '2.5rem',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: '2rem',
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: '1.75rem',
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: 400,
      lineHeight: '1.625rem',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5rem',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5rem',
    },
  },
});
